module.exports = __webpack_public_path__ + "h5/img/register-logo.12154792.png";